<template>
  <van-overlay :show="show">
    <div class="contain-bg">
      <div>
        <van-icon
          class="close-btn"
          name="close"
          size="25"
          color="white"
          @click="clickClose"></van-icon>
        <div class="contain"></div>
        <div class="bottom-bg">
          <div class="button" @click="clickCommitJoin"></div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
  <script>
import { Icon, Overlay } from "vant"
export default {
  name: "sevensuccessPop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    clickClose() {
      this.$emit("close")
    },
    clickCommitJoin() {
      this.$emit("commitUse")
    }
  }
}
</script>
  <style lang="less" scoped>
.van-overlay {
  z-index: 11;
}
.contain-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .close-btn {
    position: absolute;
    right: 20px;
  }
  .contain {
    margin-top: 40px;
    width: calc(100vw - 40px);
    height: 238px;
    background-image: url("../../../assets/img/lottery/mid/mid_enter_pop_bg.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 10px;
  }
  .bottom-bg {
    display: flex;
    justify-content: center;
    .button {
      margin-top: 30px;
      background: url("../../../assets/img/lottery/mid/mid_enter_pop_join_btn.jpg")
        no-repeat;
      background-size: 100% 100%;
      width: 221px;
      height: 50px;
    }
  }
}
</style>